import i18n from 'i18next';
import languageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import locales from 'src/locales';
import { LOCKED_LANG } from 'src/shared/constants/languages';

const detectorOptions = {
  caches: ['localStorage', 'cookie'],
  lookupCookie: 'i18next',
  lookupLocalStorage: 'i18nextLng',
  lookupQuerystring: 'lng',
  order: ['localStorage', 'cookie', 'htmlTag', 'querystring', 'path'],
};

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    detection: detectorOptions,
    defaultNS: 'common',
    fallbackLng: LOCKED_LANG || 'ru',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
    resources: locales,
  });

export default i18n;
